<template>
    <div class="home">
		<div class="home_background parallax-window" data-parallax="scroll" data-image-src="../assets/img/contact.jpg" data-speed="0.8"></div>
		<div class="home_container">
			<div class="container">
				<div class="row">
					<div class="col">
						<div class="home_content">
							<div class="home_title"><span>Securedcare</span> Contact</div>
							<div class="breadcrumbs">
								<ul>
									<li><router-link to="/">Home</router-link></li>
									<li>Contact</li>
								</ul>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>

	<!-- Contact -->

	<div class="contact">
		<div class="container">
			<div class="row">

				<!-- Contact Info -->
				<div class="col-lg-6">
					<div class="section_title"><h2>Get in touch</h2></div>
					<div class="contact_text">
						<p>Looking for a caregiver or want to become a provider? contact us today</p>
					</div>
					<ul class="contact_about_list">
						<li><div class="contact_about_icon"><img src="../assets/img/phone-call.svg" alt=""></div><span>404 988-5377</span></li>
						<li><div class="contact_about_icon"><img src="../assets/img/envelope.svg" alt=""></div><span>info@securedcares.com</span></li>
						<li><div class="contact_about_icon"><img src="../assets/img/placeholder.svg" alt=""></div><span>Dallas, GA, United States, 30157</span></li>
					</ul>
				</div>

				<!-- Contact Form -->
                <div class="col-lg-6 form_col">
                    <div id="form-response"></div>
                    <div class="contact_form_container">
                        <form @submit.prevent="submitForm" class="contact_form">

                            <div class="row">
                                <div class="col-md-6 input_col">
                                    <div class="input_container input_name">
                                        <input
                                            type="text"
                                            class="contact_input"
                                            v-model="form.name"
                                            placeholder="Name"
                                            required
                                        >
                                    </div>
                                </div>

                                <div class="col-md-6 input_col">
                                    <div class="input_container">
                                        <input
                                            type="email"
                                            class="contact_input"
                                            v-model="form.email"
                                            placeholder="E-mail"
                                            required
                                        >
                                    </div>
                                </div>
                            </div>

                            <div class="input_container">
                                <input
                                    type="text"
                                    class="contact_input"
                                    v-model="form.subject"
                                    placeholder="Subject"
                                    required
                                >
                            </div>

                            <div class="input_container">
                                <input
                                    type="text"
                                    class="contact_input"
                                    v-model="form.phone"
                                    placeholder="Phone Number"
                                    required
                                >
                            </div>

                            <div class="input_container">
                                <textarea
                                    class="contact_input contact_text_area"
                                    v-model="form.message"
                                    placeholder="Message"
                                    required
                                ></textarea>
                            </div>

                            <div class="form-group mt-3 mb-3">
                                <label>
                                    <input
                                        type="checkbox"
                                        v-model="form.sms_consent"
                                    >

                                    By checking this box, you agree to receive text messages from Secured Home Care.
                                    Reply STOP to opt out at any time. Reply HELP for support.
                                    Message and data rates may apply. Message frequency may vary.
                                    View our
                                    <router-link to="/privacy" target="_blank">Privacy Policy</router-link>
                                    and
                                    <router-link to="/privacy" target="_blank">
                                        SMS Terms & Conditions
                                    </router-link>.
                                </label>
                            </div>

                            <button
                                type="submit"
                                class="button contact_button"
                                :disabled="loading"
                            >
                                {{ loading ? 'Sending...' : 'Send Message' }}
                            </button>

                            <div v-if="responseMessage" class="mt-3">
                                {{ responseMessage }}
                            </div>

                        </form>
                    </div>
                </div>
			</div>
			<div class="row map_row">
				<div class="col">

					<!-- Contact Map -->

					<div class="contact_map">

						<!-- Google Map -->
						
						<div style="width: 100%"><iframe width="100%" height="600" frameborder="0" scrolling="no" marginheight="0" marginwidth="0" src="https://maps.google.com/maps?width=100%25&amp;height=600&amp;hl=en&amp;q=Dallas,%20GA,%20United%20States,%2030157+(Secured%20cares)&amp;t=&amp;z=14&amp;ie=UTF8&amp;iwloc=B&amp;output=embed"><a href="https://www.gps.ie/">gps devices</a></iframe></div>

						<!-- Working Hours -->
						

					</div>

				</div>
			</div>
		</div>
	</div>
</template>
<script>
import { reactive, ref } from "vue";

export default {
    name: "ContactForm",

    setup() {

        const loading = ref(false);
        const responseMessage = ref("");

        const form = reactive({
            name: "",
            email: "",
            subject: "",
            phone: "",
            message: "",
            sms_consent: false
        });

        const resetForm = () => {
            Object.assign(form, {
                name: "",
                email: "",
                subject: "",
                phone: "",
                message: "",
                sms_consent: false
            });
        };

        const submitForm = async () => {
            loading.value = true;
            try {
                const formData = new FormData();
                for (const key in form) {
                    formData.append(key, form[key]);
                }
                const response = await fetch("contact.php", {
                    method: "POST",
                    body: formData
                });
                const result = await response.json();
                if (result.success) {
                    responseMessage.value = result.message;
                    resetForm();
                } else {
                    responseMessage.value = result.message;
                }
            } catch (error) {
                responseMessage.value = "Unable to send message.";
            }

            loading.value = false;
        };

        return {
            form,
            loading,
            responseMessage,
            submitForm
        };
    }
};
</script>
<style scoped>
@import url("../assets/css/contact.css");
@import url("../assets/css/contact_responsive.css");
.home_background {
    position:absolute;
    top:0;
    left:0;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
}

.home_background::before {
    content: "";
    position: absolute;
    inset: 0;
    background: url("../assets/img/contact.jpg") center/cover no-repeat;
    will-change: transform;
    z-index: -1;
}
</style>